import { ListOption } from '@/components/list-item';
import { useMemo } from 'react';
import { useOrderGuideItemsContext } from '@/contexts/order-guide-items-context';

export type CollectionOptionType = ListOption<{
  isDefault: boolean;
  isLinked?: boolean;
  isLocked?: boolean;
  type: 'restaurant' | 'supplier';
}>;

export const useCollectionListOptions = () => {
  const { collections } = useOrderGuideItemsContext();
  return useMemo<CollectionOptionType[]>(() => {
    return collections.map<CollectionOptionType>((collection) => ({
      metadata: {
        isDefault: collection.isDefault,
        isLinked: Boolean(collection.linkedSupplierCollectionUUID),
        isLocked: collection.isLocked,
        type: collection.type,
      },
      title: collection.name,
      value: collection.uuid,
    }));
  }, [collections]);
};
